<div class="h-screen flex items-center justify-center">
  <ng-container>
    <div class="login-dialog-container">
      <div class="login-dialog-logo mb-[20px]">
        <img src="./../../../../../assets/images/nlb_logo.svg" alt="NLB logo" />
      </div>
      <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
        <label>
          {{ "login.labels.username" | transloco }}:
          <input
            type="text"
            pInputText
            class="w-full input-field"
            formControlName="username"
          />
        </label>

        <label>
          {{ "login.labels.password" | transloco }}:
          <input
            type="password"
            pInputText
            class="w-full input-field"
            formControlName="password"
          />
        </label>
        <br />
        <div
          *ngIf="loginForm.invalid && (loginForm.dirty || loginForm.touched)"
          class="error"
        >
          @if (loginForm.errors !== null && loginForm.errors["required"]) {
            <div>{{ "login.errors.invalidForm" | transloco }}</div>
          }
        </div>

        <div class="w-full items-center justify-center">
          <button
            type="submit"
            [disabled]="loginForm.invalid"
            class="mt-[20px] btnPrimary"
            pButton
          >
            {{ "login.buttons.loginButton" | transloco }}
          </button>
        </div>
      </form>
    </div>
  </ng-container>
</div>
<p-toast></p-toast>
<div
  class="progress-spinner"
  style="z-index: 10005"
  *ngIf="notificationService.isLoading$ | async"
>
  <p-progressSpinner></p-progressSpinner>
</div>
